import { DatePicker, Space } from 'antd'

import { ProDatePickerProps } from './interface'

export const ProDatePicker = ({
  addonBefore,
  ...restProps
}: ProDatePickerProps) => {
  return addonBefore ? (
    <Space.Compact>
      {addonBefore}
      <DatePicker {...restProps} />
    </Space.Compact>
  ) : (
    <DatePicker {...restProps} />
  )
}
